import { Grid, Typography, Button, Divider, Box, Chip } from '@mui/material'
import { applicationApi, useGetApplicationsByJobQuery, useUpdateApplicationMutation } from '../../../Redux/api/applicationApi'
import { useParams, useSearchParams } from 'react-router-dom'
import { skipToken } from '@reduxjs/toolkit/query'
import { KaziAvatar } from '../../../Shared Components/Kazi/KaziAvatar'
import { formatUserName } from '../../../Utils/String'
import { Fragment, ReactNode, useEffect, useState } from 'react'
import { ClientViewApplicationModal } from './ClientViewApplicationModal'
import { useUpdateJobMutation } from '../../../Redux/api/jobApi'
import { useToast } from '../../../Hooks/useToast'
import { useAppDispatch } from '../../../Redux/store'
import { IApplicationAnswer } from '../../../Types/Application'
import { useAWSWebsocket } from '../../../Hooks/useAWSWebsocket'
import { NotificationType } from '../../../Types/Notification'
import { ApplicationReview } from './ApplicationReview'
import { setApplicationReviewJob } from '../Slices/ApplicationReviewSlice'
import { useGetManyTalentsQuery } from '../../../Redux/api/talentApi'
import { useUser } from '../../../Hooks/useUser'
import { TalentPreview } from '../../../Shared Components/TalentPreview'
import { AssignmentOutlined } from '@mui/icons-material'

export const ClientApplications = () => {
    /* ******************** Hooks ******************** */
    const dispatch = useAppDispatch();
    const {locator} = useParams();
    const {user} = useUser();
    const {data: apps, isLoading: appsLoading, isFetching: appsFetching} = useGetApplicationsByJobQuery( locator || skipToken);
    //@ts-ignore
    const {data: talentInvites} = useGetManyTalentsQuery( user?.talent_invites?.filter( invite => invite.job_locator === apps?.job.locator)?.map( talent => talent.talent_locator) || skipToken);
    /* ******************** Variables ******************** */
    const isAccepted = (apps?.job?.talent_locator?.length ?? 0) > 0;
    /* ******************** Functions ******************** */
    /* ******************** Effects ******************** */
    useEffect(() => {
        if (apps) dispatch(setApplicationReviewJob(apps.job))
    }, [apps])
    /* ******************** JSX ******************** */
    return (
        <>
            {
                apps && 
                <Grid  display={'flex'} flexDirection={'column'} height={'100%'}>
                        <Box flex={1} display={'flex'} flexDirection={'column'}>
                            <Typography variant='lora-headline-small' color={'text.primary'} marginBottom={'28px'}>{apps.job?.title}</Typography>
                           {
                            apps?.applications?.length > 0 ?
                            <Grid display={'flex'} flexDirection={'column'}  marginLeft={2} gap={2}>
                                {
                                    apps?.applications.map((app, idx) => (    
                                        <Fragment key={app.locator}>                                 
                                            <ApplicationReview 
                                                application={app} 
                                                hiredTalent={apps.job?.talent_locator}
                                                denied={app.status === 'denied'}
                                            />
                                        </Fragment>   
                                    )) 
                                }
                            </Grid>
                            :
                            <Grid display={'flex'} xs flexDirection={'row'} justifyContent={'center'} alignItems={'center'} flex={1} >
                                <Grid display={'flex'} flexDirection={'row'} gap={1}>
                                    <AssignmentOutlined sx={{fontSize: '24px', color: 'green.200'}}/>
                                    <Typography>No Applicants</Typography>
                                </Grid>
                            </Grid>
                           }
                        </Box>
                        <Box flex={1} display={'flex'} flexDirection={'column'}>
                            <Typography variant='lora-headline-small' color={'text.primary'} marginBottom={'28px'}>Talent invites</Typography>
                            {
                                (talentInvites?.length ?? 0) > 0 ?
                                <Grid display={'flex'} flexDirection={'column'}  marginLeft={2} gap={2}>
                                    {
                                        talentInvites?.map((talent) => (    
                                            <Fragment key={talent.locator}>                                 
                                                <TalentPreview 
                                                    locator={talent.locator}
                                                    first_name={talent.first_name}
                                                    last_name={talent.last_name}
                                                    title={talent.title}
                                                    showNavigation
                                                />
                                            </Fragment>   
                                        ))
                                    }
                                </Grid>
                                :
                                <Grid display={'flex'} xs flexDirection={'row'} justifyContent={'center'} alignItems={'center'} flex={1} >
                                    <Grid display={'flex'} flexDirection={'row'} gap={1}>
                                        <AssignmentOutlined sx={{fontSize: '24px', color: 'green.200'}}/>
                                        <Typography>No Invites</Typography>
                                    </Grid>
                                </Grid>
                                
                            }
                        </Box>
                </Grid>
            }
        </>
    )
}